import * as React from "react";

import { Box, makeStyles, Link as MuiLink } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  stepSkip: {
    cursor: "pointer",
  },
}));

export const Link: React.FC<{
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  linkText: string;
}> = ({ onClick, linkText }) => {
  const classes = useStyles();
  return (
    <Box color="info.main">
      <strong>
        <MuiLink
          className={classes.stepSkip}
          color="inherit"
          onClick={onClick}
          rel="noopener"
          target="_blank"
        >
          {linkText}
        </MuiLink>
      </strong>
    </Box>
  );
};
